module.exports = __webpack_public_path__ + "img/news3.abc8fa67.jpg";